import { Injectable, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { BarChartComponent } from '../chart-components/bar-chart/bar-chart.component';
import { LineChartComponent } from '../chart-components/line-chart/line-chart.component';
import { PieChartComponent } from '../chart-components/pie-chart/pie-chart.component';
import { BubbleChartComponent } from '../chart-components/bubble-chart/bubble-chart.component';
import { CountComponent } from '../chart-components/step-line-chart/count.component';
import { StackedAreaChartComponent } from '../chart-components/stacked-area-chart/stacked-area-chart.component';
import { WaterfallChartComponent } from '../chart-components/waterfall-chart/waterfall-chart.component';
import { QuadBubbleChartComponent } from '../chart-components/quad-bubble-chart/quad-bubble-chart.component';
import { DrillDownComponent } from '../chart-components/drill-down/drill-down.component';
import { HorizontalBarChartComponent } from '../chart-components/horizontal-bar-chart/horizontal-bar-chart.component';
import { TreemapChartComponent } from '../chart-components/treemap-chart/treemap-chart.component';
import { LineColumnChartComponent } from '../chart-components/line-column-chart/line-column-chart.component';
import { CombinedChartComponent } from '../chart-components/combined-chart/combined-chart.component';
import { MixedStackbarChartComponent } from '../chart-components/mixed-stackbar-chart/mixed-stackbar-chart.component';
import { MatSliderComponent } from '../global-components/mat-slider/mat-slider.component';
import { WaterfallStackChartComponent } from '../chart-components/waterfall-stack-chart/waterfall-stack-chart.component';
import { InputBoxComponent } from '../global-components/input-box/input-box.component';
import { TableComponent } from '../global-components/table/table.component';
import { ConfigurableFormComponent } from '../global-components/configurable-form/configurable-form.component';
import { EditableTableComponent } from '../chart-components/editable-table/editable-table.component';
import { StackBarChartComponent } from '../chart-components/stack-bar-chart/stack-bar-chart.component';
import { DynamicEditTableComponent } from '../chart-components/dynamic-edit-table/dynamic-edit-table.component';
import { UploadFileComponent } from '../chart-components/upload-file/upload-file.component';
import { NumberStatsComponent } from '../../../../../../../projects/my-app/src/app/number-stats/number-stats.component';
import { GenericStackbarChart } from '@shared-lib/chart-components/generic-stackbar-chart/generic-stackbar-chart';
import { GenericTableComponent } from '@shared-lib/chart-components/generic-table/generic-table';
import { Notes } from '../global-components/notes/notes';
import { MultiselectToggle } from '../global-components/multiselect-toggle/multiselect-toggle';

import { MbarMline } from '@shared-lib/chart-components/mbar-mline/mbar-mline';
import { BarLine } from '@shared-lib/chart-components/bar-line/bar-line';
import { ImageShow } from '@shared-lib/global-components/image-show/image-show';


import { TreeDrillDownComponent } from '../chart-components/tree-drill-down/tree-drill-down.component';
import { DonutChartComponent } from '../chart-components/donut-chart/donut-chart.component';
// import { MixedStackbarChartComponent } from '../chart-components/mixed-stackbar-chart/mixed-stackbar-chart.component';
import { StackedHorizontalBarChartComponent } from '@shared-lib/chart-components/stacked-horizontal-bar-chart/stacked-horizontal-bar-chart.component';
import { ComparisonBarChartComponent } from '../chart-components/comparison-bar-chart/comparison-bar-chart.component';
import { MultiLevelComparisonChartComponent } from '@shared-lib/chart-components/multi-level-comparison-chart/multi-level-comparison-chart.component';
import { ClusteredBarComponent } from '@shared-lib/chart-components/clustered-bar-chart/clustered-bar-chart.component';
import { Stacked100BarComponent } from '@shared-lib/chart-components/stacked-barchart-hundred-percentage/stacked-barchart-hundred-percentage.component';
import { GanttChartComponent } from '@shared-lib/chart-components/gantt-chart/gantt-chart.component';
import { SideEntityFormComponent } from '@shared-lib/chart-components/side-entity-form/side-entity-form.component';
import { EntityManagementComponent } from '@shared-lib/chart-components/entity-management/entity-management.component';
import { HorizontalBarChartSegmentComponent } from '@shared-lib/chart-components/horizontal-bar-chart-segment/horizontal-bar-chart-segment.component';

@Injectable({
    providedIn: 'root'
})
export class ChartRendererService {
    constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

    renderChart(
        type: string,
        viewContainerRef: ViewContainerRef,
        chartData: any
    ): any {
        viewContainerRef.clear();

        // Debug: log render attempts
        // eslint-disable-next-line no-console
        console.log('[ChartRendererService] renderChart', type, chartData?.widgetId || chartData?.title || chartData);

        let component: any;
        switch (type) {
            case 'count':
                component = CountComponent;
                break;
            case 'line-chart':
                component = LineChartComponent;
                break;
            case 'comparison-bar-chart':
                component = ComparisonBarChartComponent;
                break;
            case 'bar-chart':
                component = BarChartComponent;
                break;
            case 'pie-chart':
                component = PieChartComponent;
                break;
            case 'numberstatscomponent':
            case 'number-stats':
                component = NumberStatsComponent;
                break;
            case 'bubble-chart':
                component = BubbleChartComponent;
                break;
            case 'stacked-area-chart':
                component = StackedAreaChartComponent;
                break;
            case 'waterfall-chart':
                component = WaterfallChartComponent;
                break;
            case 'quad-bubble-chart':
                component = QuadBubbleChartComponent;
                break;
            case 'drill-down':
                component = DrillDownComponent;
                break;
            case 'barline':
            case 'bar_line':
            case 'bar-line':
                component = BarLine;
                break;
            case 'horizontal-bar-chart':
                component = HorizontalBarChartComponent;
                break;
            case 'treemap-chart':
                component = TreemapChartComponent;
                break;
            case 'line-column-chart':
                component = LineColumnChartComponent;
                break;
            case 'slider':
                component = MatSliderComponent;
                break;
            case 'combined-chart':
                component = CombinedChartComponent;
                break;
            case '`mixed-stackbar-chart`':
                component = MixedStackbarChartComponent;
                break;
            case 'waterfall-stack':
                component = WaterfallStackChartComponent;
                break;
            case 'input-box':
                component = InputBoxComponent;

                break;
            case 'configurable-form':
                component = ConfigurableFormComponent;

                break;
            case 'editable-table':
                component = EditableTableComponent;
                break;
            case 'table':
                component = TableComponent;
                break;
            case 'stack-bar-chart':
                component = StackBarChartComponent;
                break;
            case 'dynamic-edit-table':
                component = DynamicEditTableComponent;
                break;
            case 'upload-file':
                component = UploadFileComponent;
                break;
            case 'notes':
                component = Notes;
                break;
            case 'static-screen':
                component = ImageShow;
                break;
            case 'multiselect-toggle':
                component = MultiselectToggle;
                break;

            case 'mbar-mline':
                component = MbarMline;
                break;

            case 'multi-level-comparison-chart':
                component = MultiLevelComparisonChartComponent;
                break;
            case 'clustered-bar-chart':
                component = ClusteredBarComponent;
                break;
            case 'stacked-100-bar-chart':
                component = Stacked100BarComponent;
                break;

            // Generic components (use utilities for all functionality)
            case 'generic-stack-bar-chart':
            case 'stack-bar-chart-generic':
                component = GenericStackbarChart;
                break;
            case 'generic-table':
            case 'table-generic':
                component = GenericTableComponent;

                break;
            case 'tree-drill-down':
                component = TreeDrillDownComponent;
                break;
            case 'donut-chart':
                component = DonutChartComponent;
                break;
            case 'mixed-stackbar-chart':
                component = MixedStackbarChartComponent;
                break;
            case 'stacked-horizontal-bar-chart':
                component = StackedHorizontalBarChartComponent;
                break;
            case 'gantt-chart':
                component = GanttChartComponent;
                break;
            case 'entity-table':
                component = EntityManagementComponent;
                break;
            case 'entity-form':
                component = SideEntityFormComponent;
                break;
            case 'horizontal-bar-chart-segment':
                component = HorizontalBarChartSegmentComponent;
                break;

            default:
                console.error(`Unknown chart type: ${type}`);
                return;
        }

        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        const componentRef = viewContainerRef.createComponent(componentFactory);

        if (componentRef.instance) {
            (componentRef.instance as any).data = chartData;
        }

        return componentRef;
    }
}
